
namespace GeniuzPOS.PosShift {
    import fld = PsPosShiftControlRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PsPosShiftControlGrid extends Serenity.EntityGrid<PsPosShiftControlRow, any> {
        protected getColumnsKey() { return PsPosShiftControlColumns.columnsKey; }
        protected getDialogType() { return PsPosShiftControlDialog; }
        protected getIdProperty() { return PsPosShiftControlRow.idProperty; }
        protected getInsertPermission() { return PsPosShiftControlRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosShiftControlRow.localTextPrefix; }
        protected getService() { return PsPosShiftControlService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createQuickSearchInput() {
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.SingInDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-6));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["ShopId"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "ShopId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["ShopId"];
            //     };
            // }


            return filters;
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsPosShiftControlService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}